import gql from 'graphql-tag';

import client from '../graphqlAPI';

const GET_EMAIL_TEMPLATE_PREVIEW = gql`
query previewEmailTemplate($templateId: String!, $sampleDataJson: String) {
  previewEmailTemplate(templateId: $templateId, sampleDataJson: $sampleDataJson) {
    isAuth
    error
    preview {
      subject
      html
      text
      usedVariables
      unprovidedVariables
      providedVariables
    }
  }
}
`;

const getEmailTemplatePreview = async (variables) => {
  try {
    const result = await client.query({
      query: GET_EMAIL_TEMPLATE_PREVIEW,
      variables,
      errorPolicy: 'all',
      fetchResults: true,
      fetchPolicy: 'no-cache',
    })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const { data: { previewEmailTemplate: previewData } } = result;

    if (previewData) {
      return previewData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: getEmailTemplatePreview = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: getEmailTemplatePreview Error: ${error}`);
    return null;
  }
};

export default getEmailTemplatePreview;
